// import { extend } from "quasar";

import _get from "lodash.get";

export const body = state => state.bodyReference.body;

export const getErrorsClicked = state => state.errorsClicked;

export const parsedAPI = state => state.parsed.apis;

export const getSubmitActionsList = state => state.submitActionsList;

export const getFilteredOutcomes = state => state.filteredOutcomes;

export const getAssistantVis = state => state.assistantVisibility;

export const getAssistantForceOpen = state => state.assistantForceOpen;

export const getCurrentInterface = state => {
    let interfaceTitle;
    if (state.activeInterface) {
        interfaceTitle = state.currentInterfaceProperties.name;
        // if (state.activeInterface === "draft") {
        // } else {
        //     const properties = state.appInterfaces.find(interfaceEntry => interfaceEntry.id === state.activeInterface) || null;
        //     if (properties) {
        //         interfaceTitle = properties.name;
        //     }
        // }
    } else {
        interfaceTitle = state.emptyInterface.name;
    }
    return interfaceTitle;
};
/*

export const currentInterfaceProperties = state => {
    let properties;
    if (state.activeInterface) {
        properties = state.appInterfaces.find(interfaceEntry => interfaceEntry.id === state.activeInterface) || {};
        // properties = extend(true, {}, state.appInterfaces.find(interfaceEntry => interfaceEntry.id === state.activeInterface) || {});
    } else {
        properties = state.emptyInterface;
    }

    return properties
};
*/

export const activeComponentParent = state => (state.activeComponent ? state.properties[state.activeComponent].parent : null);

export const getRichTextCacheByKey = state => key => {
    let content = null;

    if ((key || "").includes(",")) {
        const path = key.split(",").slice(-2).reverse();
        content = _get(state.richTextCache, path, null);
    } else {
        content = state.richTextCache[key];
    }

    return content;
};

export const getElementState = state => ({ ns, guid }) => {
    const path = ns ? [ns, guid] : [guid];
    return _get(state.elementState, path, null);
};
